import { IMediaDraft, IMediaFile } from "@home-health-notify/domain";
import { useEffect } from "react";
import { PreviewBody, PreviewHeader, PreviewLoader } from "./Preview";
import { PreviewContainer } from "./Preview.style";
import { ThumbImages } from "./ThumbImages";

interface IFileUploader {
  mediaDrafts: IMediaDraft[];
  openFileDialog: () => void;
  onRemoveFile: (mediaDraft: IMediaDraft) => void;
  previewDraft: IMediaDraft | undefined;
  onSetPreview: (mediaDraft: IMediaDraft) => void;
  isDropAccepted: boolean;
  isDragActive: boolean;
  upload: () => Promise<void>;
  onSetCaption: (mediaDraft: IMediaDraft, caption: string) => void;
  isThumbnailCreated: boolean;
  isProcessingFiles: boolean;
  resetThumbnailFlag: () => void;
  closePreview: () => void;
}

const FileUploader = ({
  mediaDrafts,
  openFileDialog,
  onRemoveFile,
  previewDraft,
  onSetPreview,
  closePreview,
  isDropAccepted,
  isDragActive,
  upload,
  onSetCaption,
  isThumbnailCreated,
  resetThumbnailFlag,
  isProcessingFiles,
}: IFileUploader) => {
  const onSetPreviewDraft = (previewFile: IMediaFile) => {
    onSetPreview(mediaDrafts.find(md => md.mediaFile === previewFile)!);
  };

  const onRemoveDraft = (file: IMediaFile) => {
    onRemoveFile(mediaDrafts.find(md => md.mediaFile === file)!);
  };

  useEffect(() => {
    if (!isDragActive && !isProcessingFiles && mediaDrafts.length === 0) {
      closePreview();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewDraft, mediaDrafts, isProcessingFiles]);

  return (
    <PreviewContainer>
      <PreviewHeader closePreview={closePreview} />
      {isDragActive && <PreviewLoader />}
      {isDropAccepted && previewDraft && (
        <PreviewBody messageDraft={previewDraft} onSetCaption={onSetCaption} />
      )}
      <ThumbImages
        files={mediaDrafts.map(md => md.mediaFile)}
        openFileDialog={openFileDialog}
        previewFile={previewDraft?.mediaFile}
        onSetPreview={onSetPreviewDraft}
        onRemoveFile={onRemoveDraft}
        upload={upload}
        isThumbnailCreated={isThumbnailCreated}
        resetThumbnailFlag={resetThumbnailFlag}
      />
    </PreviewContainer>
  );
};

export default FileUploader;
